import './src/styles/global.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'swiper/css';
import 'aos/dist/aos.css';
import AOS from 'aos';

AOS.init();
